export default __webpack_public_path__ + "static/media/login-background.568e47be.svg";